// src/components/store/sections/hero-banner/HeroV23BentoshowcaseFuchsiaGlow.tsx
"use client";

import React from "react";
import DynamicHeroVariant from "./DynamicHeroVariant";

export default function HeroV23BentoshowcaseFuchsiaGlow(props: any) {
  return (
    <DynamicHeroVariant
      variantNumber={23}
      archKey="bento_showcase"
      archLabel="Bento Multi-Tile Hero"
      palName="FuchsiaGlow"
      grad="from-fuchsia-500 via-pink-500 to-purple-700"
      lightBg="bg-fuchsia-50"
      textCol="text-fuchsia-700"
      borderCol="border-fuchsia-200"
      btnCls="bg-fuchsia-600 hover:bg-fuchsia-700"
      {...props}
    />
  );
}
